/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cta_Client_Sign_InInputs */

const en_landing_cta_client_sign_in = /** @type {(inputs: Landing_Cta_Client_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client sign in`)
};

/**
* | output |
* | --- |
* | "Client sign in" |
*
* @param {Landing_Cta_Client_Sign_InInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_cta_client_sign_in = /** @type {((inputs?: Landing_Cta_Client_Sign_InInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cta_Client_Sign_InInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_cta_client_sign_in(inputs)
});